import { db } from "../../../firebase";
import { ref, query, orderByKey, limitToFirst, startAfter, get } from "firebase/database";

export async function getUsersPage(pageNo = 1, pageSize = 25) {
  const usersRef = ref(db, "users");

  let lastKey = null;

  // Loop through pages until reaching target page
  for (let i = 1; i < pageNo; i++) {
    const q = lastKey
      ? query(usersRef, orderByKey(), startAfter(lastKey), limitToFirst(pageSize))
      : query(usersRef, orderByKey(), limitToFirst(pageSize));

    const snapshot = await get(q);
    if (!snapshot.exists()) return [];

    const data = snapshot.val();
    const keys = Object.keys(data);

    lastKey = keys[keys.length - 1];
  }

  // Load actual page data
  const pageQuery = lastKey
    ? query(usersRef, orderByKey(), startAfter(lastKey), limitToFirst(pageSize))
    : query(usersRef, orderByKey(), limitToFirst(pageSize));

  const finalSnap = await get(pageQuery);

  if (!finalSnap.exists()) return [];

  const finalData = finalSnap.val();

  return Object.keys(finalData).map((id) => ({
    id,
    ...finalData[id],
  }));
}

export async function getUserCount() {
  const snapshot = await get(ref(db, "users"));
  if (!snapshot.exists()) return 0;

  return Object.keys(snapshot.val()).length;
}
